import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from 'web-library';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';



import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export interface ChangeExamSeriesModalProps {
  modelOpen: boolean;
  onClickRemoveCandidate: () => void;
  candidateName?: string;
  onClose: (value?: string) => void;
}

const RemoveCandidateModal = ({
  modelOpen,
  onClickRemoveCandidate,
  candidateName,
  onClose,
}: ChangeExamSeriesModalProps) => {
  const handleClose = () => {
    onClose();
  };
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog onClose={handleClose} open={modelOpen} maxWidth="sm">
      <DialogTitle>{t('withdrawal->>Coordinator.SelectCandidates.RemoveCandidate')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('withdrawal->>Coordinator.SelectCandidates.RemoveCandidatePartOne')}
          <b>{candidateName}</b>
          {t('withdrawal->>Coordinator.SelectCandidates.RemoveCandidatePartTwo')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box className={classes.buttonContainer}>
          <Button
            id="button-cancel-delete-candidate"
            type="button"
            variant="text"
            size="small"
            color="secondary"
            onClick={handleClose}
          >
            {t('withdrawal->>Coordinator.SelectCandidates.Cancel')}
          </Button>
          <Button
            id="button-proceed-remove-candidate"
            type="button"
            color="secondary"
            size="small"
            onClick={() => onClickRemoveCandidate()}
          >
            {t('withdrawal->>Coordinator.SelectCandidates.Proceed')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveCandidateModal;
